var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 3.09375C8.11523 3.12305 7.79297 3.15234 7.5 3.24023C7.64648 3.47461 7.70508 3.76758 7.73438 4.03125C7.73438 4.93945 6.97266 5.67188 6.09375 5.67188C5.80078 5.67188 5.50781 5.61328 5.30273 5.4668C5.21484 5.75977 5.15625 6.05273 5.15625 6.375C5.15625 8.19141 6.62109 9.65625 8.4375 9.65625C10.2539 9.65625 11.7188 8.19141 11.7188 6.375C11.7188 4.58789 10.2539 3.12305 8.4375 3.12305V3.09375ZM16.7578 5.96484C15.1758 2.85938 12.0117 0.75 8.4375 0.75C4.83398 0.75 1.66992 2.85938 0.0878906 5.96484C0.0292969 6.08203 0 6.22852 0 6.375C0 6.55078 0.0292969 6.69727 0.0878906 6.81445C1.66992 9.91992 4.83398 12 8.4375 12C12.0117 12 15.1758 9.91992 16.7578 6.81445C16.8164 6.69727 16.8457 6.55078 16.8457 6.4043C16.8457 6.22852 16.8164 6.08203 16.7578 5.96484ZM8.4375 10.5938C5.53711 10.5938 2.87109 8.98242 1.46484 6.375C2.87109 3.76758 5.53711 2.15625 8.4375 2.15625C11.3086 2.15625 13.9746 3.76758 15.3809 6.375C13.9746 8.98242 11.3086 10.5938 8.4375 10.5938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.6c6c41d48eb87adfb6168159078768bc.svg";
export { ForwardRef as ReactComponent };